import { differenceInCalendarMonths, endOfMonth, endOfYear, getYear, startOfMonth, startOfYear, subMonths, subYears } from 'date-fns';
import { isoDate, monthYearFormat, yearFormat } from '../../utils/date-formatter';
export const numberOfBars = 60;
export const emptyHistogram = {
  bars: [],
  formatTooltip: () => '',
  maxValue: 0
};
export const toHistogram = (dates, t) => {
  if (dates.length) {
    if (shouldRenderYearHistogram(dates)) {
      return getYearHistogram(dates, t);
    }
    return getMonthHistogram(dates);
  }
  return emptyHistogram;
};
const shouldRenderYearHistogram = dates => numberOfBars < differenceInCalendarMonths(Date.now(), new Date(dates[dates.length - 1].date));
const getMonthHistogram = dates => {
  let maxValue = 0;
  if (dates.length) {
    const now = Date.now();
    const monthResultMap = dates.reduce((accumulator, {
      date,
      count
    }) => {
      const monthDiff = differenceInCalendarMonths(startOfMonth(now), new Date(date));
      const currentCountOfMonth = accumulator[monthDiff] || 0;
      const newCountOfMonth = count + currentCountOfMonth;
      maxValue = Math.max(maxValue, newCountOfMonth);
      return {
        ...accumulator,
        [monthDiff]: newCountOfMonth
      };
    }, {});
    const bars = Array(numberOfBars).fill({}).map((_, index) => {
      const currentMonth = subMonths(now, index);
      return {
        from: isoDate(startOfMonth(currentMonth)),
        to: isoDate(endOfMonth(currentMonth)),
        count: monthResultMap[index] || 0
      };
    }).reverse();
    return {
      bars,
      maxValue,
      from: monthYearFormat(bars[0].from),
      to: monthYearFormat(bars[bars.length - 1].to),
      formatTooltip: date => monthYearFormat(date)
    };
  }
  return emptyHistogram;
};
const getYearHistogram = (dates, t) => {
  let maxValue = 0;
  if (dates.length) {
    const now = Date.now();
    const yearResultMap = dates.reduce((results, {
      date,
      count
    }) => {
      const year = getYear(new Date(date));
      const currentYearCount = results[year] || 0;
      const newYearCount = count + currentYearCount;
      maxValue = Math.max(maxValue, newYearCount);
      return {
        ...results,
        [year]: newYearCount
      };
    }, {});
    const bars = Array(numberOfBars).fill({}).map((_, index) => {
      const currentYear = subYears(now, index);
      return {
        from: isoDate(startOfYear(currentYear)),
        to: isoDate(endOfYear(currentYear)),
        count: yearResultMap[getYear(currentYear)] || 0
      };
    }).reverse();
    return {
      bars,
      maxValue,
      from: yearFormat(bars[0].from),
      to: yearFormat(bars[bars.length - 1].to),
      formatTooltip: date => `${t('global.year')} ${yearFormat(date)}`
    };
  }
  return emptyHistogram;
};